import type { ResolvedInstallationLineItem } from "../types/installation";
import { readInstallationLineTaxable } from "../utils/readResolveTaxable";

/** Map saved installation order line_items → resolve line shape for UI pricing after GET/save. */
export function mapInstallationOrderLinesToResolved(
  lineItems: unknown[] | null | undefined
): ResolvedInstallationLineItem[] {
  return (lineItems || [])
    .filter((raw) => {
      const li = raw as { is_new_purchase?: boolean };
      return li?.is_new_purchase === true;
    })
    .map((raw) => {
      const li = raw as Record<string, unknown>;
      const qty = Math.max(1, Number(li.quantity ?? 1));
      const unitPrice = Number(li.unit_price ?? li.unit_retail_price ?? 0);
      const changedUnitPrice = Number(li.changed_unit_price ?? unitPrice);
      return {
        product_id: String(li.product_id ?? ""),
        variant_id: String(li.variant_id ?? ""),
        product_name: String(li.product_name ?? ""),
        sku: String(li.sku ?? ""),
        inventory_source: String(li.inventory_source ?? ""),
        is_new_purchase: true,
        quantity: qty,
        unit_price: unitPrice,
        changed_unit_price: changedUnitPrice,
        is_price_overridden:
          li.is_price_overridden === true || li.manual_unit_price_override === true,
        item_sub_total: Number(
          li.item_sub_total ?? round2(changedUnitPrice * qty)
        ),
        total_price: Number(li.total_price ?? 0),
        discount_on_unit_quantity: Number(li.discount_on_unit_quantity ?? 0),
        discount_on_total_quantity: Number(
          li.discount_on_total_quantity ?? li.discount ?? li.discount_amount ?? 0
        ),
        discount_code: String(li.discount_code ?? ""),
        is_taxable: readInstallationLineTaxable(li, true),
        item_tax_info: li.item_tax_info as ResolvedInstallationLineItem["item_tax_info"],
      };
    });
}

function round2(n: number): number {
  return Math.round((Number(n) + Number.EPSILON) * 100) / 100;
}
